export const LANDING = "/";
export const LOGIN = "/login";
export const FIRSTLOGIN = "/usersetup";
export const PRIVACY = "/privacy";
export const ADMIN = "/admin";
